import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import NotFound from "../pages/NotFound";
import { routes } from "./routes_data";
export const AppRouter: React.FC = () => {

  return (
    <Router>
      <Routes>
        <Route path="/">
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <route.layout>
                  <route.component />
                </route.layout>
              }
            />
          ))}
        </Route>
        <Route path="/404-not-found" element={<NotFound />} />
        <Route
          path="*"
          element={<Navigate to={{ pathname: "/404-not-found" }} />}
        />
      </Routes>
    </Router>
  );
};
